import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J208 (研發樣品繳庫單)
// ============================================================

export interface FJ190 {
  fj190_01: string;          // 繳庫單號 (PK)
  fj190_10: string;          // 採購/托工單號
  fj190_11: string | null;   // 繳庫日期 (ISO string)
  fj190_12: string;          // 繳庫庫位
  fj190_13: boolean;         // 確認旗標
  fj190_14: string;          // 部門
  fj190_15: number;          // 金額合計
  fj190_16: number;          // 來源筆數
  fj190_17: string;          // 來源類型
  fj190_18: string;          // 來源單號
  fj190_19: string | null;   // 來源日期 (ISO string)
  fj190_20: string;          // 系統欄位
  fj190_21: string | null;   // 系統日期
  fj190_22: number;          // 總項次
  fj190_23: string;          // 入單人員
  fj190_24: string;          // 廠商代號
  fj190_25: string;          // 工繳代號
  fj190_26: number;          // 工繳計價方式 (1=計量/2=計缸)
  fj190_27: string;          // 幣別
  fj190_30: number;          // 單據來源 (1=採購/2=托工)
  fj190_80: string;          // 核准狀態 N/P
  fj190_89: string;          // 系統備用
  fj190_90: number;          // 版次
  fj190_91: string;          // modifier
  fj190_92: string | null;   // modify date
  fj190_93: string;          // modify note
  details?: FJ191[];
}

export interface FJ191 {
  fj191_01: string;          // 繳庫單號 FK
  fj191_02: number;          // 項次
  fj191_10: string;          // 產品大類碼
  fj191_11: string;          // 產品細類碼
  fj191_12: string;          // 色號
  fj191_121: string;         // 中文色名
  fj191_122: string;         // 英文色名
  fj191_12a: string;         // CBNO.
  fj191_13: number;          // 繳庫數量
  fj191_14: string;          // 單位
  fj191_15: number;          // 未稅單價
  fj191_151: number;         // 含稅單價
  fj191_16: number;          // 未稅金額
  fj191_161: number;         // 含稅金額
  fj191_17: string;          // 等級
  fj191_171: string;         // 非A級品原因
  fj191_18: number;          // 架號/換算率
  fj191_19: string;          // 產品名稱
  fj191_20: string;          // 產品規格
  fj191_21: string;          // 加工別
  fj191_22: number;          // 針孔內
  fj191_23: number;          // 針孔外
  fj191_24: number;          // 碼重
  fj191_25: number;          // 米平方重
  fj191_26: string;          // 單位
  fj191_27: string;          // 產品碼
  fj191_28: number;          // 計數
  fj191_29: string;          // 備用碼
  fj191_90: number;
  board_numbers?: FJ192[];
}

export interface FJ192 {
  fj192_01: string;          // 繳庫單號 FK
  fj192_02: number;          // 項次 FK
  fj192_03: number;          // 板號序號
  fj192_11: string;          // 板號
  fj192_90: number;
  fj192_91: string;
  fj192_92: string | null;
  fj192_93: string;
}

// ============================================================
// Request / Response types
// ============================================================

export interface J208ListResponse {
  data: FJ190[];
  total: number;
  page: number;
  size: number;
}

export interface J208CreateRequest {
  master: Partial<FJ190>;
  details: Partial<FJ191>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j208Api = {
  async list(page = 1, size = 20): Promise<J208ListResponse> {
    const res = await apiClient.get('/api/j208', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FJ190> {
    const res = await apiClient.get(`/api/j208/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: J208CreateRequest): Promise<FJ190> {
    const res = await apiClient.post('/api/j208', data);
    return res.data;
  },

  async update(id: string, data: J208CreateRequest): Promise<FJ190> {
    const res = await apiClient.put(`/api/j208/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/j208/${encodeURIComponent(id)}`);
  },
};
